<div class="row">
  <div class="col">
    <button class="btn btn-outline-secondary btn-sm float-left ml-2" (click)="exportarExcel()">
      <em class="fa fa-download fa-xs"></em>
      Export Excel
    </button>
  </div>
</div>
<div class="conteudo">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="row mt-2">
    </div>
    <div class="content">
      <p-table #dt dataKey="id" [value]="tempDados" selectionMode="single" styleClass="p-datatable-responsive-demo
          p-datatable-striped
          p-datatable-sm" [columns]="selectedColumns" [columns]="cols" [value]="rows" [autoLayout]="true"
        id="excel-table" class="style">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th [translate]="getTranslate(col.header)" [pSortableColumn]="col.field">
                {{col.header}}
                <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dados let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <td class="text-center percentual" *ngFor="let col of columns"
              [ngStyle]="{backgroundColor:getColor(dados)}">
              <div *ngIf="col.field === 'detalhe'">
                <button class="btn btn-ver" (click)="getById(rowIndex)" pTooltip="Detalhes do Dealer">
                  <i class="far fa-file-alt" style="cursor: pointer;"></i>
                </button>
              </div>
              <div [ngClass]="{'text-center': col.field !== 'codigo_dealer' && col.field !== 'nome_dealer'}">
                {{ col.type ? col.type.transform(dados[col.field], col.arg2) : dados[col.field] }}
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr class="tr-footer">
            <td>

            </td>
            <td>
              {{quantidadeDealers}}
            </td>
            <td [translate]="getTranslate(nome_dealer)">
              {{nome_dealer}}
            </td>
            <td>
              {{estoque | number: '1.0-0'}}
            </td>
            <td>
              {{manter | number: '1.0-0'}}
            </td>
            <td>
              {{comprar | number: '1.0-0'}}
            </td>
            <td class="text-center percentual" style="background-color:black;color:white;">
              {{percentual | percent: '1.0-0'}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
